// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageGallery_container__23pXz","image":"ImageGallery_image__Qhog8","close":"ImageGallery_close__2Taaj","hide":"ImageGallery_hide__J55gh"};